<template>
<div class="paddingv20 clearfix" v-if="data.length">
    <cmui-list :col="col" :space="space">
        <cmui-list-item v-for="item in data">
            <a href="{{item.clickUrl}}" class="dis-b bg-white pos-r radiusShadow"
               :data-scp="$options.name+'.'+$index"
               :data-bk="'item-'+item.id"
               :data-trace-id="item.traceId ? item.traceId : ''">
                <div class="pos-r ratio-container">
                    <img alt="" :src="item.imageUrl" onerror="this.src='//image1.51tiangou.com/tgou2/img/bg-load.png!s'">
                    <div class="pos-a left20 bottom20" style="top:auto" v-show="showTip && item.tip">
                        <div class="badge black pill small" style="padding:4px 5px;background: rgba(0,0,0,.6)"><span v-text="item.tip"></span></div>
                    </div>
                    <div class="pos-a" v-if="showTag && item.actTagImageUrl"
                         :style="bigTag?'left:0;right:0;top:0;bottom:0;width:auto;height:auto;':'width: 40px;height: 40px;left: auto;right: 10px;top:auto;bottom: 10px;'">
                        <img :src="item.actTagImageUrl" alt="">
                    </div>
                </div>
                <div class="padding20">
                    <div class="text-darker fs-13 text-fixed2">
                        <!--显示旗舰店标签-->
                        <span class="border-radius fs-10 text-white bg-red"
                              style="padding:1px 2px;font-size:10px;"
                              :class="tagClass"
                              v-if="type && showYtTag">{{type}}</span>
                        <div class="counterBadge badge badge-round badge-green badge-radius badge-small" v-if="item.newest">新</div>{{item.title}}
                    </div>
                    <div class="margint10" style="height: 21px;overflow: hidden;">
                        <div v-if="item.tags && item.tags.couponList">
                            <div class="text-red text-limit1 fs-11 paddingh10 counter_ribbon marginr10" v-for="i in item.tags.couponList"><div>{{i}}</div></div>
                        </div>
                        
                    </div>
                    <div class="margint10 pos-r">
                        <div v-if="item.tags.newPrice">
                            <span class="fs-19 text-red marginr10 text-bolder">¥{{item.tags.newPrice}}</span>
                            <span class="text-red">新人价</span>
<!--                            <span class="text-lighter text-delete fs-11">¥{{item.price}}</span>-->
                        </div>
                        <div class="fs-11 flex-container left" v-if="item.tags.groupPrice && !(item.tags.newPrice)">
                            <span class="text-red marginr10">拼团价</span>
                            <span class="fs-19 text-red marginr10 text-bolder">¥{{item.tags.groupPrice}}</span>
                            <span class="text-darker fs-11">单买价¥{{item.price}}</span>
                        </div>
                        <div class="flex-container left bottom lh-1" v-if="!(item.tags && item.tags.groupPrice) && !(item.tags && item.tags.newPrice)">
                            <span class="fs-18 text-red marginr10"><span class="fs-12">¥</span>{{item.price}}</span>
                            <span class="text-light text-delete fs-12" v-show="item.originalPrice&&(item.originalPrice!=item.price)">¥{{item.originalPrice}}</span>
                        </div>
                        <div class="pos-a top0 right10" data-scp="addCar.{{$index}}" v-if="showCar" @click.stop.prevent="itemEvent(item)">
                            <span class="text-red fs-15 flex-container center border-round" style="width:30px;height:30px;border:1px solid #CCC">
                                <i class="icon-cart"></i>
                            </span>
                        </div>
                        <div class="flex-container left" v-if="item.tags.vipPrice">
                            <span class="text-black fs-14"><span class="fs-12">¥</span>{{ item.tags.vipPrice }}</span>
                            <img src="//image1.51tiangou.com/tgou2/img2/product/ico-up_05.png" width="48" alt="">
                        </div>
                    </div>
                </div>
            </a>
        </cmui-list-item>
    </cmui-list>
</div>
</template>
<style lang="scss">
    .radiusShadow{
        border-radius:8px;
        /*box-shadow: 0px 0px 5px rgba(0,0,0,.2);*/
        overflow:hidden;
    }
    .counter_ribbon{
      display:inline-block;
      position: relative;
      height:20px;
      line-height: 20px;
      text-align: center;
      vertical-align: middle;
      white-space: nowrap;
      overflow: hidden;
      background:rgba(255,34,56,.05);
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    }
    .counter_ribbon:before{
        position: absolute;
        top: 0;
        left: -3px;
        bottom: 0;
        height: 6px;
        width: 6px;
        border-radius: 50%;
        background: #fff;
        margin: auto;
        content: "";
    }
    .ribbon_next {
        display: inline-block;
        position: relative;
        height: 18px;
        min-width: 28px;
        border-radius: 0;
        padding: 0;
        background: #fff6f6;
        font-size: 10px;
        line-height: 16px;
        text-align: center;
        vertical-align: middle;
        white-space: nowrap;
        overflow: hidden;
    }
    .ribbon_next>div{
        border: 1px solid #ffa4a2;
        padding:0 5px;
    }
    .ribbon_next:before,
    .ribbon_next:after {
        position: absolute;
        top: 0;
        bottom: 0;
        height: 6px;
        width: 6px;
        border-radius: 50%;
        background: #fff;
        margin: auto;
        content: "";
        border: 1px solid #ffa4a2;
    }
    .ribbon_next:before {
        left: -3px;
    }

    .ribbon_next:after {
        right: -3px;
    }
    .bg-green2{
        background: #16cc90;
    }
    .bg-green{
        background-color: #06B621;
    }
</style>
<script>
import itemService from '../../api/item.js'
export default {
    props:{
        data:{
            type:Array,
            default:[]
        },
        space:{
            type:Number,
            default:30
        },
        showCar:{
            type:Boolean,
            default:false
        },
        col:{
            type:Number,
            default:2
        },
        showTip:{ // 是否显示极速达标签
            type:Boolean,
            default:false
        },
        showTag:{// 是否显示右下角水印
            type:Boolean,
            default:false
        }
        , bigTag: {
            type: Boolean
            , default: false
        }
        ,type:{
            type: String
            , default: ''
        }
	    , tagClass: {
		    type: String
		    , default: ''
	    },
        // 是否展示商品的业态标
        showYtTag: {
            type: Boolean,
            default: true
        }
    },
    // created(){
    //   console.log(this.data)
    // },
    computed: {
        localData(){
            // return this.data;
        }
    },
    methods:{
        itemEvent(item){
            itemService.addShoppingCart({
                data:{
                    itemId:item.id,
                    quantity:1
                },
                success(){
                    maple.notice('加入购物车成功')
                }
            })
        }
    }
}
</script>